import { graphql } from "src/graphql/generated";

export const downloadExportJobMutation = graphql(/* GraphQL */ `
    mutation DownloadExportJob($jobId: String!) {
        downloadExportJob(jobId: $jobId)
    }
`);
